<div class="mobile-wrapper edit-posting-form">
  <h3 class="content-card-title mobile-hide">{{damagesFormTranslations.textDamages}}</h3>
  <div class="content-card-subtitle">{{damagesFormTranslations.textAddPhotos}}</div>
  <div class="damage-card-list container">
    @for (damageForm of damageForms; track damageForm; let i = $index) {
      <div [attr.data-index]="i">
        @if (!isMobile()) {
          <div>
            <ng-content *ngTemplateOutlet="damageCardDesktop; context:{ damage: damageForm, i: i }"></ng-content>
          </div>
        }
        @if (isMobile()) {
          <div>
            <ng-content *ngTemplateOutlet="damageCardMobile; context:{ damage: damageForm, i: i }"></ng-content>
          </div>
        }
      </div>
    }
  </div>
  @if (openFormIndex === null) {
    <button class="add-damage mobile-hide position-relative"
      data-track-name="Add Damage Information"
      [attr.aria-label]="'Add More Damage Information'"
      (click)="isAddDamageOpen = !isAddDamageOpen">
      {{damagesFormTranslations.btnAddDamageInfo}}
    </button>
  }
  @if (openFormIndex === null) {
    <button class="add-damage desktop-hide position-relative"
      data-track-name="Add Damage Information"
      [attr.aria-label]="'Add More Damage Information'"
      (click)="isAddDamageOpen = !isAddDamageOpen">
      {{damagesFormTranslations.btnAddDamageInfo}}
    </button>
  }
</div>

<ng-template #damageCardDesktop let-damage="damage" let-i="i">
  <div class="row">
    <div class="damage-card-container col">
      <div class="damage-card-header row">
        <div class="col-2">
          {{damagesFormTranslations.textPhoto}}
        </div>
        <div class="col-4">
          {{damagesFormTranslations.textDamage}}
        </div>
        <div class="col-4">
          {{damagesFormTranslations.textEstimatedCose}}
        </div>
        <div class="col-2"></div>
      </div>
      @if (damages && damages[i]) {
        <div class="damage-card-content row" >
          <div class="col-2">
            <div class="damage-photo">
              @if (damages && damages[i]?.exceptionImages?.length) {
                <lib-images-count
                  [img]="damages[i].exceptionImages[0].url || damages[i].exceptionImages[0].sourceUrl"
                  [count]="damages[i].exceptionImages?.length">
                </lib-images-count>
              }
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col">
                <label for="type-{{i}}">{{damagesFormTranslations.labelType}} </label>
                <span id="type-{{i}}">{{damages[i].type}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="location-{{i}}">{{damagesFormTranslations.labelLocation}}: </label>
                <span id="location-{{i}}">{{damages[i].location | nameTruncate: 25}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="description-{{i}}">{{damagesFormTranslations.labeldescription}}: </label>
                <span id="description-{{i}}">{{damages[i].description | nameTruncate: 25}}</span>
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="row">
              <div class="col">
                <label for="total-{{i}}">{{damagesFormTranslations.labelTotal}} </label>
                <span id="total-{{i}}">{{damages[i].total != null && damages[i].total !== 0
                ? formatCurrency(damages[i].total) : 'N/A'}}</span>
              </div>
            </div>
          </div>
          <div class="col-2 align-self-end">
            <ng-content *ngTemplateOutlet="editRemoveButtons; context:{ i: i}"></ng-content>
          </div>
        </div>
      }
      <div class="row">
        <ng-content *ngTemplateOutlet="editDamageInformation; context:{ damage: damage, i: i }"></ng-content>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #damageCardMobile let-damage="damage" let-i="i">
  @if (damages && damages[i]) {
    <div class="mobile-padding">
      <div class="row">
        <div class="col">
          <div class="damage-photo mb-3">
            @if (damages && damages[i]?.exceptionImages?.length) {
              <lib-images-count
                [img]="damages[i].exceptionImages[0].url || damages[i].exceptionImages[0].sourceUrl"
                [count]="damages[i].exceptionImages?.length">
              </lib-images-count>
            }
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="type-mobile-{{i}}">{{damagesFormTranslations.labelType}} </label>
          <span id="type-mobile-{{i}}">{{damages[i].type}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="location-{{i}}">{{damagesFormTranslations.labelLocation}}: </label>
          <span id="location-mobile-{{i}}">{{damages[i].location | nameTruncate: 25}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <label for="description-{{i}}">{{damagesFormTranslations.labeldescription}}: </label>
          <span id="description-mobile-{{i}}">{{damages[i].description | nameTruncate: 25}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <ng-content *ngTemplateOutlet="editRemoveButtons; context:{ i: i}"></ng-content>
        </div>
      </div>
    </div>
  }
  <div class="row">
    <ng-content *ngTemplateOutlet="editDamageInformation; context:{ damage: damage, i: i }"></ng-content>
  </div>
  <div class="row horizontal-divider mobile-padding">
  </div>
</ng-template>

<ng-template #editDamageInformation let-damage="damage" let-i="i">
  <accordion
    class="damage-accordion"
    [attr.aria-expanded]="openFormIndex === i"
    >
    <div [ngClass]="openFormIndex == i ? 'arrow-box arrow-box-edit' : ''"></div>
    <div [ngClass]="openFormIndex == i ? 'arrow-shadow arrow-shadow-edit' : ''"></div>
    <div [ngClass]="openFormIndex == i ? 'arrow-border arrow-border-edit' : ''"></div>
    <div [ngClass]="openFormIndex == i ? 'fake-shadow' : ''"></div>
    <accordion-group panelClass="edit-information-{{i}}"
      class="edit-information-panel"
      isDisabled="true">
      <form [formGroup]="damage" (keydown.enter)="$event.preventDefault()" nonvalidate>
        <div class="edit-container container">
          <!-- Mobile Close Button -->
          <div class="row desktop-hide">
            <ng-content *ngTemplateOutlet="closeButton; context:{ i: i }"></ng-content>
          </div>
          <div class="row edit-form">
            <div class="col-12 d-flex">
              <div class="col ps-0">
                <h3 class="content-card-title">{{damagesFormTranslations.textEditDamageInfo}}</h3>
                @if (damage.get('totalErrors').value > 0) {
                  <div class="validation-error">
                    {{errorText(damage)}}
                  </div>
                }
                <div class="form-group">
                  <label for="damage-type-{{i}}">{{damagesFormTranslations.textDamageType}}</label>
                  <div class="select-wrapper">
                    <select id="damage-type-{{i}}"
                      [attr.aria-required]="true"
                      [attr.aria-label]="damagesFormTranslations.ariaLabelDamageTypeSelect"
                            [ngClass]="showError(i, 'type')
                            ? 'custom-select wrapText error-border type-select' : 'custom-select wrapText type-select'"
                      formControlName="type">
                      <option [ngValue]="null">{{damagesFormTranslations.textSelect}}</option>
                      @for (option of damageTypeOptions; track option) {
                        <option [ngValue]="option">
                          {{option}}
                        </option>
                      }
                    </select>
                  </div>
                  @if (showError(i, 'type')) {
                    <div class="validation-error">
                      {{damagesFormTranslations.textSelectDamageType}}
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label for="damage-location-{{i}}">{{damagesFormTranslations.labelLocation}}</label>
                  <span
                    [ngClass]="showError(i, 'location')
                           ? 'form-control error-border character-count-input'
                           : 'form-control character-count-input'" >
                    <input id="damage-location-{{i}}"
                      [attr.aria-label]="damagesFormTranslations.ariaLabelLocationInput"
                      [attr.aria-required]="true"
                      maxlength="40" formControlName="location"
                      />
                  </span>
                  <p class="text-end fw-bold" style="font-size: 11px">
                    {{damage.controls.location.value?.length}}/40 {{damagesFormTranslations.textCharacter}}
                  </p>
                  @if (showError(i, 'location')) {
                    <div class="validation-error">
                      {{damagesFormTranslations.textEnterDamageLocation}}
                    </div>
                  }
                </div>
                <div class="form-group">
                  <label for="damage-description-{{i}}">{{damagesFormTranslations.labeldescription}}</label>
                  <span
                    [ngClass]="showError(i, 'description')
                           ? 'form-control error-border character-count-input'
                           : 'form-control character-count-input'" >
                    <input id="damage-description-{{i}}"
                      [attr.aria-label]="damagesFormTranslations.textDescriptionInput"
                      [attr.aria-required]="true"
                      maxlength="50" formControlName="description"
                      />
                  </span>
                  <p class="text-end fw-bold" style="font-size: 11px">
                    {{damage.controls.description.value?.length}}/50 {{damagesFormTranslations.textCharacter}}
                  </p>
                  @if (showError(i, 'description')) {
                    <div class="validation-error">
                      {{damagesFormTranslations.textEnterDamageDescription}}
                    </div>
                  }
                </div>
                <div class="form-group">
                  <div class="excess-wear-message">
                    <strong>
                      {{damagesFormTranslations.textExcessWear}}
                      <a class="tenant-text"
                        href="../../../../../ui/assets/documents/Excess_Wear_Table.pdf"
                        target="_blank"
                        data-track-name="SmartAuction standards"
                        rel="noopener"
                        >
                        {{damagesFormTranslations.textStandard}}
                      </a>?
                    </strong>
                  </div>

                  <div class="control-wrapper mt-3">
                    <div class="custom-control custom-radio custom-control-inline ">
                      <input type="radio" id="chargeable-yes-{{i}}" class="custom-control-input"
                        [attr.aria-label]="damagesFormTranslations.ariaLabelStandardInputYes"
                        formControlName="chargeableFlag" [value]="true" (change)="handleTotalField(damage)"/>
                      <label class="custom-control-label " for="chargeable-yes-{{i}}">{{commonTranslations.btnYes}}</label>
                    </div>
                  </div>

                  <div class="control-wrapper mt-3">
                    <div class="custom-control custom-radio custom-control-inline ">
                      <input type="radio" id="chargeable-no-{{i}}" class="custom-control-input"
                        [attr.aria-label]="damagesFormTranslations.ariaLabelStandardInputNo"
                        formControlName="chargeableFlag" [value]="false" (change)="handleTotalField(damage)"/>
                      <label class="custom-control-label " for="chargeable-no-{{i}}">{{commonTranslations.btnNo}}</label>
                    </div>
                  </div>
                </div>
                <div class="form-group">
                  <label for="damage-cost-{{i}}">{{damagesFormTranslations.labelEstimatedCost}}</label>
                  <div class="input-wrapper">
                    <span class="dollar-sign" [ngClass]="isFrenchCanadian ? 'canadian' : 'american'">$</span>
                    @if (!isFrenchCanadian) {
                      <input id="damage-cost-{{i}}"
                        [ngClass]="handleDisabledAndErrorStyling(damage, showError(i, 'total'))"
                        class="american-input form-control currency-input"
                        [attr.aria-label]="damagesFormTranslations.ariaLabelEstimateCostInput"
                        [attr.aria-required]="!damage.get('total').disabled"
                        mask="separator.2"
                        thousandSeparator=","
                        separatorLimit="100000"
                        [allowNegativeNumbers]="false"
                        formControlName="total"/>
                    }
                    @if (isFrenchCanadian) {
                      <input id="damage-cost-{{i}}"
                        [ngClass]="handleDisabledAndErrorStyling(damage, showError(i, 'total'))"
                        class="canadian-input form-control currency-input"
                        [attr.aria-label]="damagesFormTranslations.ariaLabelEstimateCostInput"
                        [attr.aria-required]="!damage.get('total').disabled"
                        mask="separator.2"
                        thousandSeparator=" "
                        decimalMarker=","
                        separatorLimit="100000"
                        [allowNegativeNumbers]="false"
                        formControlName="total"/>
                    }
                  </div>
                  @if (showError(i, 'total')) {
                    <div class="validation-error">
                      {{damagesFormTranslations.textEnterCostRepairs}}
                    </div>
                  }
                </div>
              </div>
              <div class="col pe-0 mobile-hide">
                <ng-content *ngTemplateOutlet="closeButton; context:{ i: i }"></ng-content>
              </div>
            </div>
            <div class="col-12 mt-2">
              <h5 class="content-card-title">{{damagesFormTranslations.textDamagePhotoOptional}}</h5>
              <div class="content-card-subtitle mb-1 ps-0">{{damagesFormTranslations.textSelectFive}}</div>
              <div class="tire-photo-selection-links">
                <button
                  type="button"
                  id="damage-new-photo"
                  class="btn btn-link p-0"
                  data-track-name="Upload new"
                  [attr.aria-label]="damagesFormTranslations.btnUploadNew"
                  (click)="selectPhotos(i)"
                  >
                  {{damagesFormTranslations.btnUploadNew}}
                </button>
                @if (existingPhotoList.length || (damages && damages[i]?.exceptionImages?.length)) {
                  <span class="divider">|</span>
                  <button
                    type="button"
                    id="damage-existing-photo"
                    class="btn btn-link p-0"
                    [attr.aria-label]="damagesFormTranslations.ariaLabelSelectExisting"
                    data-track-name="Select existing"
                    (click)="showExistingModal(i)"
                    >
                    {{damagesFormTranslations.ariaLabelSelectExisting}}
                  </button>
                }
              </div>
              @if (damages && damages[i]?.showErrMsg) {
                <div class="mt-2 error-msg">{{errMsg}}</div>
              }
              @if (damages && damages[i]?.exceptionImages?.length) {
                <div class="photos-container photos-no-location mb-3">
                  <app-photos-card
                    [photoList]="damages[i].exceptionImages"
                    [flowName]="damages[i].location + i"
                    [currIndex]="i"
                    (photosCardDeletionStatus)="actionBarUpdatesFromPhotosCard($event)"
                  ></app-photos-card>
                </div>
              }
            </div>
            <div class="col edit-damage-information-buttons mt-3">
              <button
                class="btn btn-outline-primary add-damage-button"
                data-track-name="Add Damage"
                (click)="updateDamage(i)"
                [attr.aria-label]="damagesFormTranslations.ariaLabelAddDamage">
                {{damagesFormTranslations.ariaLabelAddDamage}}
              </button>
              <button class="cancel-button"
                data-track-name="Cancel"
                (click)="clickAccordion(i, true)"
                [attr.aria-label]="damagesFormTranslations.ariaLabelCancelEditDamage">
                {{commonTranslations.btnCancel}}
              </button>
            </div>
          </div>
        </div>
      </form>
    </accordion-group>
  </accordion>
</ng-template>

<ng-template #closeButton let-i="i">
  <div class="col">
    @if (configuration) {
      <button
        class="close-button"
        [attr.aria-label]="damagesFormTranslations.ariaLabelCloseEditDamage"
        data-track-name="Close Edit Damage"
        (click)="clickAccordion(i, true)"
        >
        <img
          src="../../../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
          alt="{{commonTranslations.altCloseModelIcon}}">
      </button>
    }
  </div>
</ng-template>

<ng-template #editRemoveButtons let-i="i">
  <div class="edit-remove-links">
    <button
      id="edit-damage-{{i}}"
      (click)="clickAccordion(i)"
      data-track-name="Edit Damage"
      [attr.aria-label]="damagesFormTranslations.ariaLabelEditDamage"
      >
      {{damagesFormTranslations.btnEdit}}
    </button>
    <span class="divider">|</span>
    <button
      id="remove-damage-{{i}}"
      (click)="removeDamage(i)"
      data-track-name="Remove Damage"
      [attr.aria-label]="damagesFormTranslations.ariaLabelRemoveDamage"
      >
      {{damagesFormTranslations.btnRemove}}
    </button>
  </div>
</ng-template>

<accordion class="damage-accordion">
  <accordion-group class="edit-information-panel" panelClass="add-damage-information" [isOpen]="isAddDamageOpen" (isOpenChange)="addDamageChangeEvent($event)">
    @if (addDamageForm) {
      <div class="damage-card-container add-damage-information">
        <div [ngClass]="'arrow-box arrow-box-add'"></div>
        <div [ngClass]="'arrow-shadow arrow-shadow-add'"></div>
        <div [ngClass]="'arrow-border arrow-border-add'"></div>
        <div [ngClass]="'fake-shadow'"></div>
        <form [formGroup]="addDamageForm" (keydown.enter)="$event.preventDefault()" nonvalidate>
          <div class="edit-container container">
            <!-- Mobile Close Button -->
            <div class="row desktop-hide">
              <ng-content *ngTemplateOutlet="addDamageCloseButton"></ng-content>
            </div>
            <div class="row edit-form">
              <div class="col-12 d-flex">
                <div class="col ps-0">
                  <h3 class="content-card-title">{{damagesFormTranslations.textEditDamageInfo}}</h3>
                  @if (addDamageForm.get('totalErrors').value > 0) {
                    <div class="validation-error">
                      {{errorText(addDamageForm)}}
                    </div>
                  }
                  <div class="form-group">
                    <label for="add-damage-type">{{damagesFormTranslations.textDamageType}}</label>
                    <div class="select-wrapper">
                      <select id="add-damage-type"
                        [attr.aria-required]="true"
                        [attr.aria-label]="damagesFormTranslations.ariaLabelDamageTypeSelect"
                            [ngClass]="showAddDamageFormError('type')
                            ? 'custom-select wrapText error-border type-select' : 'custom-select wrapText type-select'"
                        formControlName="type">
                        <option [ngValue]="null">{{damagesFormTranslations.textSelect}}</option>
                        @for (option of damageTypeOptions; track option) {
                          <option [ngValue]="option">
                            {{option}}
                          </option>
                        }
                      </select>
                    </div>
                    @if (showAddDamageFormError('type')) {
                      <div class="validation-error">
                        {{damagesFormTranslations.textSelectDamageType}}
                      </div>
                    }
                  </div>
                  <div class="form-group">
                    <label for="damage-location">{{damagesFormTranslations.labelLocation}}</label>
                    <span
                    [ngClass]="showAddDamageFormError('location')
                           ? 'form-control error-border character-count-input'
                           : 'form-control character-count-input'" >
                      <input id="add-damage-location"
                        [attr.aria-label]="damagesFormTranslations.ariaLabelLocationInput"
                        [attr.aria-required]="true"
                        maxlength="40" formControlName="location"
                        />
                    </span>
                    <p class="text-end fw-bold" style="font-size: 11px">
                      {{addDamageForm.controls.location.value?.length}}/40 {{damagesFormTranslations.textCharacter}}
                    </p>
                    @if (showAddDamageFormError('location')) {
                      <div class="validation-error">
                        {{damagesFormTranslations.textEnterDamageLocation}}
                      </div>
                    }
                  </div>
                  <div class="form-group">
                    <label for="damage-description">{{damagesFormTranslations.labeldescription}}</label>
                    <span
                    [ngClass]="showAddDamageFormError('description')
                           ? 'form-control error-border character-count-input'
                           : 'form-control character-count-input'" >
                      <input id="add-damage-description"
                        [attr.aria-label]="damagesFormTranslations.textDescriptionInput"
                        [attr.aria-required]="true"
                        maxlength="50" formControlName="description"
                        />
                    </span>
                    <p class="text-end fw-bold" style="font-size: 11px">
                      {{addDamageForm.controls.description.value?.length}}/50 {{damagesFormTranslations.textCharacter}}
                    </p>
                    @if (showAddDamageFormError('description')) {
                      <div class="validation-error">
                        {{damagesFormTranslations.textEnterDamageDescription}}
                      </div>
                    }
                  </div>
                  <div class="form-group">
                    <div class="excess-wear-message">
                      <strong>
                        {{damagesFormTranslations.textExcessWear}}
                        <a class="tenant-text"
                          href="../../../../../ui/assets/documents/Excess_Wear_Table.pdf"
                          target="_blank"
                          data-track-name="SmartAuction standards"
                          rel="noopener"
                          >
                          {{damagesFormTranslations.textStandard}}
                        </a>?
                      </strong>
                    </div>
                    <div class="control-wrapper mt-3">
                      <div class="custom-control custom-radio custom-control-inline ">
                        <input type="radio" id="chargeable-yes" class="custom-control-input"
                          [attr.aria-label]="damagesFormTranslations.ariaLabelStandardInputYes"
                          formControlName="chargeableFlag" [value]="true" (change)="handleTotalField(addDamageForm)"/>
                        <label class="custom-control-label " for="chargeable-yes">{{commonTranslations.btnYes}}</label>
                      </div>
                    </div>
                    <div class="control-wrapper mt-3">
                      <div class="custom-control custom-radio custom-control-inline ">
                        <input type="radio" id="chargeable-no" class="custom-control-input"
                          [attr.aria-label]="damagesFormTranslations.ariaLabelStandardInputNo"
                          formControlName="chargeableFlag" [value]="false" (change)="handleTotalField(addDamageForm)"/>
                        <label class="custom-control-label " for="chargeable-no">{{commonTranslations.btnNo}}</label>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="damage-cost">{{damagesFormTranslations.labelEstimatedCost}}</label>
                    <div class="input-wrapper">
                      <span class="dollar-sign" [ngClass]="isFrenchCanadian ? 'canadian' : 'american'">$</span>
                      @if (!isFrenchCanadian) {
                        <input id="add-damage-cost"
                          [ngClass]="handleDisabledAndErrorStyling(addDamageForm, showAddDamageFormError('total'))"
                          class="american-input form-control currency-input"
                          [attr.aria-label]="damagesFormTranslations.ariaLabelEstimateCostInput"
                          [attr.aria-required]="!addDamageForm.get('total').disabled"
                          mask="separator.2"
                          thousandSeparator=","
                          separatorLimit="100000"
                          [allowNegativeNumbers]="false"
                          [formControl]="addDamageForm.controls['total']"/>
                      }
                      @if (isFrenchCanadian) {
                        <input id="add-damage-cost"
                          [ngClass]="handleDisabledAndErrorStyling(addDamageForm, showAddDamageFormError('total'))"
                          class="canadian-input form-control currency-input"
                          [attr.aria-label]="damagesFormTranslations.ariaLabelEstimateCostInput"
                          [attr.aria-required]="!addDamageForm.get('total').disabled"
                          mask="separator.2"
                          thousandSeparator=" "
                          decimalMarker=","
                          separatorLimit="100000"
                          [allowNegativeNumbers]="false"
                          [formControl]="addDamageForm.controls['total']"/>
                      }
                    </div>
                    @if (showAddDamageFormError('total')) {
                      <div class="validation-error">
                        {{damagesFormTranslations.textEnterCostRepairs}}
                      </div>
                    }
                  </div>
                </div>
                <div class="col pe-0 mobile-hide">
                  <ng-content *ngTemplateOutlet="addDamageCloseButton"></ng-content>
                </div>
              </div>
              <div class="col-12 mt-2">
                <h5 class="content-card-title">{{damagesFormTranslations.textDamagePhotoOptional}}</h5>
                <div class="content-card-subtitle mb-1 ps-0">{{damagesFormTranslations.textSelectFive}}</div>
                <div class="tire-photo-selection-links">
                  <button
                    type="button"
                    id="damage-new-photo"
                    class="btn btn-link p-0"
                    data-track-name="Upload new"
                    [attr.aria-label]="damagesFormTranslations.btnUploadNew"
                    (click)="checkForNewDamageIsValid(false, newDmgFormIndex)"
                    >
                    {{damagesFormTranslations.btnUploadNew}}
                  </button>
                  @if (existingPhotoList.length || damages && damages[newDmgFormIndex]?.exceptionImages?.length) {
                    <span class="divider">|</span>
                    <button
                      type="button"
                      id="tire-existing-photo"
                      class="btn btn-link p-0"
                      [attr.aria-label]="damagesFormTranslations.ariaLabelSelectExisting"
                      data-track-name="Select existing"
                      (click)="checkForNewDamageIsValid(true, newDmgFormIndex)"
                      >
                      {{damagesFormTranslations.ariaLabelSelectExisting}}
                    </button>
                  }
                </div>
                @if (damages && damages[newDmgFormIndex]?.showErrMsg) {
                  <div class="mt-2 error-msg">{{errMsg}}</div>
                }
                @if (damages && damages[newDmgFormIndex]?.exceptionImages?.length) {
                  <div class="photos-container photos-no-location mb-3">
                    <app-photos-card
                      [photoList]="damages[newDmgFormIndex].exceptionImages"
                      [flowName]="'Damage'"
                      [currIndex]="newDmgFormIndex"
                      (photosCardDeletionStatus)="actionBarUpdatesFromPhotosCard($event)"
                    ></app-photos-card>
                  </div>
                }
              </div>
              <div class="col edit-damage-information-buttons mt-3">
                <button
                  class="btn btn-outline-primary add-damage-button"
                  (click)="updateNewDamage(newDmgFormIndex)"
                  data-track-name="Add Damage"
                  [attr.aria-label]="damagesFormTranslations.ariaLabelAddDamage">
                  {{damagesFormTranslations.ariaLabelAddDamage}}
                </button>
                <button id="add-damage"
                  class="cancel-button"
                  data-track-name="Cancel"
                  (click)="closeAddDamageForm()"
                  [attr.aria-label]="damagesFormTranslations.ariaLabelCancelEditDamage">
                  {{commonTranslations.btnCancel}}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    }
  </accordion-group>
</accordion>

<ng-template #addDamageCloseButton>
  <div class="col">
    @if (configuration) {
      <button
        class="close-button"
        data-track-name="Close Add Damage"
        [attr.aria-label]="damagesFormTranslations.ariaLabelCloseAddDamage"
        (click)="closeAddDamageForm()"
        >
        <img
          src="../../../../../ui/assets/assets-{{ configuration.tenantName }}/{{ configuration.tenantName }}-close.svg"
          alt="{{commonTranslations.altCloseModelIcon}}"/>
      </button>
    }
  </div>
</ng-template>

<app-existing-photos-modal
  [origninalPhotoList]="existingPhotoList"
  [maxPhotoSelection]="5"
  (selectedExistingImages)="photosFromExistingModal($event)">
</app-existing-photos-modal>
